import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

const SwitchHelper = ({ components, paths, layout: Layout }) => (
	<Switch>
		{paths.map(([path, componentString, options = {}]) => {
			const Component = components[componentString];
			if (!Component) {
				throw new Error(`Route Error: Component ${componentString} not found`);
			}
			const props = {};
			if (!Layout || options.layout === false) props.component = Component;
			else
				props.render = (props) => (
					<Layout {...props}>
						<Component {...props} />
					</Layout>
				);
			return <Route exact key={options.key ?? path} path={path} {...props} />;
		})}
	</Switch>
);

SwitchHelper.propTypes = {
	components: PropTypes.object.isRequired,
	paths: PropTypes.array.isRequired,
	layout: PropTypes.func,
};

export default SwitchHelper;
